<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput";
import Icon from "@/pages/components/form/input-only/icon.vue";

export default {
	mixins: [formInput],
	components: {FormGroup, Icon},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		showBootstrapMessage: {
			type: Boolean,
			default: true,
		}
	}
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label">{{ label }}</template>
		<Icon
			v-bind="$attrs"
			:form="form"
			:name="name"
			:id="renderedId"
			:model-value="modelValue"
			:show-bootstrap-message="showBootstrapMessage"
			@update:modelValue="changeModelValueTo"
		>
			<template #addonbefore v-if="$slots.addonbefore"><slot name="addonbefore" /></template>
			<template #addonafter v-if="$slots.addonafter"><slot name="addonafter" /></template>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</Icon>
	</FormGroup>
</template>